<template>
    <div class='ba-container ba-gp-08 ba-ai-baseline ba-w-100 ba-grid'>
      <div v-if="showExitPopupAlert" class='ba-alert ba-info ba-w-100'>
          <span v-text="$t('ct-bundle-exit-popup-message')"></span>
      </div>
      <Breadcrumbs v-if="$route.name == 'Home'" />
      <builderall-loader :loading='loadingDashboardData || loadingAll' class='ba-card ba-card-grid ba-w-100' v-if="$route.name == 'Dashboard'">
        <div class='ba-top'>
          <span class='ba-title ba-h-100 ba-ai-center'>{{ $t('ct-activity') }}</span>
          <div class='ba-box-items ba-flex ba-gp-08'>
            <div class='ba-box-tabs'>
              <a 
                @click="periodDashboardData = 'week'; getDashboardUserData()"
                :class="['ba-tab', periodDashboardData == 'week' ? 'ba-is-active' : '']"
              >{{ $t('ct-7-days') }}</a>
              <a 
                @click="periodDashboardData = 'month'; getDashboardUserData()"
                :class="['ba-tab', periodDashboardData == 'month' ? 'ba-is-active' : '']"
              >{{ $t('ct-30-days') }}</a>
              <a 
                @click="periodDashboardData = 'all'; getDashboardUserData()"
                :class="['ba-tab', periodDashboardData == 'all' ? 'ba-is-active' : '']"
              >{{ $t('ct-all-time') }}</a>
            </div>
          </div>
        </div>
        <div class='ba-content'>
          <div class='ba-card ba-statistics'>
            <div class='ba-top'>
              <span class='ba-icon'>
                <builderall-icon code='b456'></builderall-icon>
              </span>
              <span class='ba-title'>{{ $t('ct-websites') }}</span>
            </div>
            <div class='ba-content ba-jc-fs'>
              <span class='ba-data' v-text="dashboardData.qty_websites"></span>
            </div>
          </div>
          <hr class='ba-hr-column'>
          <div class='ba-card ba-statistics'>
            <div class='ba-top'>
              <span class='ba-icon'>
                <builderall-icon code='9ee6'></builderall-icon>
              </span>
              <span class='ba-title'>{{ $t('ct-domains') }}</span>
            </div>
            <div class='ba-content ba-jc-center'>
              <span class='ba-data' v-text="dashboardData.qty_domains"></span>
            </div>
          </div>
          <hr class='ba-hr-column'>
          <div class='ba-card ba-statistics'>
            <div class='ba-top'>
              <span class='ba-icon'>
                <builderall-icon code='1fea'></builderall-icon>
              </span>
              <span class='ba-title'>{{ $t('ct-visitors') }}</span>
            </div>
            <div class='ba-content ba-jc-fs'>
              <span class='ba-data' v-text="dashboardData.qty_visits"></span>
            </div>
          </div>
        </div>
      </builderall-loader>
      <builderall-loader :loading="loadingContentData || loadingAll" class='ba-card ba-w-100'>
        <div class='ba-top'>
          <span class='ba-title ba-h-100 ba-ai-center'>{{ $t('ct-my-websites') }}</span>
          <div class='ba-box-items ba-flex ba-gp-08'>
            <SearchInput v-if="websites.normal && websites.normal.length >= 0" @search="paginationChange(1)" :config="filters" />
            <router-link data-ba-i="create-website" :to="{ name: 'CreateWebsite', query: { step: 'template' } }"
              class="ba-btn ba-md ba-blue">
              <builderall-icon code='2780'></builderall-icon>
              {{ $t('ct-create-website') }}
            </router-link>
          </div>
        </div>
        <div class='ba-content ba-w-100'>
          <div v-if="!firstWebsite">
            <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100 ba-mg-y-1'>
              <div class="ba-flex">
                <div class="builder-action-multiple-websites_checkbox-all pr-2">
                  <button v-if="selectWebsites.type === 'all' || selectWebsites.total > 0" class='ba-btn ba-btn-trash ba-sm ba-rounded mr-2'
                    @click="deletedWebsites">
                      <builderall-icon code='trash' />
                  </button>
                  <input 
                    id="select-websites-all" 
                    ref="select-all-websites" 
                    :checked="selectWebsites.type === 'all'"
                    type="checkbox" class="mr-2" 
                    @change.prevent="selectedWebsitesAll"
                  >
                  <label 
                    for="select-websites-all"
                    v-if="selectWebsites.type === 'unitary'"
                    class="builder-action-multiple-websites_checkbox-all-label"
                  >
                    {{ $t('ct-websites-selected-all')}}
                  </label>
                  <label 
                    for="select-websites-all"
                    v-if="selectWebsites.type === 'all'"
                    class="builder-action-multiple-websites_checkbox-all-label"
                  >
                    {{ $t('ct-websites-unselect-all')}}
                  </label>
                  
                  <!-- <div v-if="selectWebsites.type === 'all' || selectWebsites.total > 0"
                    class="text-danger mx-2 cursor-pointer" @click="deletedWebsites">
                    <i class="ct-icon-trash" />
                  </div> -->
                </div>
                <hr class='ba-hr-column'>
                <div 
                  ba-tooltip-position='bottom' 
                  ba-tooltip-title='Display Mirror Websites on the list.'
                  class="ba-flex ba-ai-center pl-2"
                  :class="selectMirrors ? 'ba-color-blue1' : 'ba-color-dark5'"
                  @click.stop="selectMirrors = !selectMirrors"
                >
                    <font-awesome-icon
                      :icon="['fas', selectMirrors ? 'eye' : 'eye-slash']"
                      class="font-awesome-icon eye-icon mr-2"
                      style="width: 17px !important"
                    />
                  <label 
                    for="select-mirrors-websites"
                    class="builder-action-multiple-websites_checkbox-all-label"
                  >
                    {{ $t('ct-mirrors-websites')}}
                  </label>
                </div>
              </div>
              <div class="ba-flex ba-gp-08 ba-ai-center">
                <select class='ba-select ba-md' v-model="filterSitesOrder">
                    <option value='alphabetical_desc'>Z - A</option>
                    <option value='alphabetical_asc'>A - Z</option>
                    <option value='creation_asc'>{{ $t('ct-creation') }} {{ $t('ct-ascending') }}</option>
                    <option value='creation_desc'>{{ $t('ct-creation') }} {{ $t('ct-descending') }}</option>
                    <option value='edition_asc'>{{ $t('ct-edition') }}</option>
                </select>
                <select class='ba-select ba-md' v-model="filterPublishedUnpublished">
                    <option value=''>{{ $t('ct-all') }}</option>
                    <option value='active'>{{ $t('ct-published') }}</option>
                    <option value='inactive'>{{ $t('ct-unpublished') }}</option>
                </select>
                <div class="dashboard-choose-view ba-flex">
                  <div :class="{ 'selected': typeView === 'card' }" @click="typeView = 'card'"><i
                      class="ct-icon-dash-card" />
                  </div>
                  <div :class="{ 'selected': typeView === 'list' }" @click="typeView = 'list'"><i
                      class="ct-icon-dash-list" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Websites Published -->
            <div v-if="!websites || !websites.normal">
              <builderall-empty-image />
            </div>
            <div v-else-if="!selectMirrors">
              <div class="custom-container">
                <div class="container-box col-sm-12 col-md-12 col-12 col-lg-12">
                  <template v-if="loading">
                    <skeleton-card-site-component v-for="n in websitesLength.normal" :key="`${n}-published`" />
                  </template>
                  <template v-else>
                    <site-card-component v-for="(website, index) in websites.normal" :config="website"
                      :categories="categories" :key="index" :type_view="typeView" :select-websites="selectWebsites"
                      website_type="websites" @openCategory="openNewCategory" @updateWebsites="updateWebsites"
                      @uploadImagePage="uploadImagePage" @openPublicLink="openPublicLink" @publish="publish"
                      @changeUnitary="changeUnitary" @checkedSelectAll="checkedSelectAll" />
                  </template>
                </div>
              </div>

              <div class="ba-pd-2 ba-mg-t-1" v-if="(websites.normal && pagination.normal.total > pagination.normal.per_page)">
                  <pagination-component :pagination="pagination.normal" :offset="4" @paginate="paginationChange" />
              </div>
            </div>

            <!-- Websites mirrors -->
            <div v-else>
              <div class="custom-container">
                <div class="container-box col-sm-12 col-md-12 col-12 col-lg-12">
                  <template v-if="loading">
                    <skeleton-card-site-component v-for="n in websitesLength.mirrors" :key="`${n}-unpublished`" />
                  </template>
                  <template v-else>
                    <div v-if="websites.mirrors.length === 0" class="row w-100 px-5 my-4">
                      <h1 class="text-center text-secondary w-100" v-text="$t('ct-no-mirrors-yet')" />
                    </div>

                    <site-card-component v-for="(website, index) in websites.mirrors" :config="website"
                      :categories="categories" :key="index" :type_view="typeView" :select-websites="selectWebsites"
                      website_type="mirror" @openCategory="openNewCategory" @updateWebsites="updateWebsites"
                      @uploadImagePage="uploadImagePage" @openPublicLink="openPublicLink" @publish="publish"
                      @changeUnitary="changeUnitary" @checkedSelectAll="checkedSelectAll" />
                  </template>
                </div>
              </div>

              <div class="ba-pd-2 ba-mg-t-1" v-if="pagination.mirrors && (pagination.mirrors.total > pagination.mirrors.per_page)">
                  <pagination-component :pagination="pagination.mirrors" :offset="4" />
              </div>
            </div>
            <!-- Websites Unpublished -->
            <site-new-component v-if="typeView === 'card'" :new-site="newSite" :categories="categories"
              :languages="languages" @confirmSave="confirmSave" @clearNewSite="clearNewSite" @closeModal="closeModal"
              @reloadWebsites="getWebsitesData" />
          </div>
        </div>
      </builderall-loader>

      <FirstWebsite v-show="firstWebsite" />

      <site-transfer-component :site="modal.transfer.config" :show="modal.transfer.show"
        @updateWebsites="updateWebsites" />

      <site-publish-component ref="publish-modal" :website="modal.publish.config" :show="modal.publish.show"
        @updateWebsites="updateWebsites" @openSaveTour="openSaveTour" @cancel="cancelModal('publish')" />

      <template v-if="modal.saveTour.config && modal.saveTour.config.layouts.length > 0">
        <save-website-component :id_layout="modal.saveTour.config.layouts[0].encrypted_id"
          :id_website="modal.saveTour.config.encrypted_id" :type="modal.saveTour.type" :show="modal.saveTour.show"
          @closeAction="cancelModal('saveTour')" />
      </template>

      <site-public-link-component :site="modal.publicLink.config" :action="modal.publicLink.action"
        :show="modal.publicLink.show" @openPublicLink="openPublicLink" @updateWebsites="updateWebsites" />

      <modal-delete-component :show="modal.delete.show" :values="modal.delete.config" @cancel="cancelModal('delete')"
        @exclude="deleteWebsite" />

      <site-category-component ref="categoryModal" @updateWebsites="updateWebsites" @newCategory="newCategory"
        @cancel="cancelCategory" />

      <move-category :show="modal.moveCategory.show" :config="modal.moveCategory.website" :categories="categories"
        @openNewCategory="openNewCategory" @updateWebsites="updateWebsites" />

      <!-- MODAL DELETE SELECT WEBSITES   -->
      <sweet-modal ref="confirmDeleteSelectedWebsites" width="496px" hide-close-button
        class="modal-confirm-deleted-websites" blocking>
        <alert-box-new-component :with_icon="true" type="danger">
          <span slot="content">{{ $t('ct-modal-deleted-attention') }}</span>
        </alert-box-new-component>
        <p v-if="selectWebsites.selectedWebsites.length === 1">{{ $t('ct-modal-deleted-website-description') }}</p>
        <p v-else>{{ $t('ct-modal-deleted-websites-description') }}</p>

        <button slot="button" class="btn btn-outline-light"
          @click.prevent="$refs.confirmDeleteSelectedWebsites.close()">{{
            $t('ct-cancel') }}
        </button>
        <button slot="button" class="btn btn-danger" @click.prevent="confirmDeletedWebsites">{{ $t('ct-delete') }}
        </button>
      </sweet-modal>

      <!-- MODAL DELETE SELECT WEBSITES   -->
      <sweet-modal ref="confirmDeleteSelectedAllWebsites" width="496px" hide-close-button
        class="modal-confirm-deleted-websites" blocking>
        <alert-box-new-component :with_icon="true" type="danger">
          <span slot="content">{{ $t('ct-modal-deleted-attention') }}</span>
        </alert-box-new-component>
        <p>{{ $t('ct-modal-deleted-all-websites-description') }}</p>

        <div class="form-group">
          <label for="email">{{ $t('ct-modal-deleted-confirm-email') }}</label>
          <input type="email" id="email" class="form-control" :placeholder="$t('ct-email')" v-model="confirm_email"
            required />
        </div>

        <button slot="button" class="btn btn-outline-light"
          @click.prevent="$refs.confirmDeleteSelectedAllWebsites.close()">{{
            $t('ct-cancel') }}
        </button>
        <button slot="button" class="btn btn-danger" @click.prevent="confirmDeletedWebsites">{{ $t('ct-delete') }}
        </button>
      </sweet-modal>

      <sweet-modal ref="alertDisconnectDomain" width="25%" hide-close-button blocking>
        <div v-if="modal.alertDisconnectDomain.action === 'transfer'">{{ $t('ct-disconnect-domain-before-transfer') }}
        </div>
        <div v-else>{{ $t('ct-disconnect-domain-before-delete') }}</div>
        <button slot="button" class="btn btn-outline-primary mt-2" @click="closeAlertDisconnectDomain">{{ $t('ct-ok')
          }}
        </button>
      </sweet-modal>
    </div>
   
</template>

<script>

import ModalComponent from './components/Modal.vue';
import ModalUploadImageComponent from './components/ModalUploadImage';
import PaginationComponent from './components/Pagination.vue';

import NavComponent from './layout/nav/Nav.vue';
import SiteNewComponent from './layout/site/SiteNew.vue';
import SiteCardComponent from './layout/site/SiteCard.vue';
import SkeletonCardSiteComponent from './layout/site/SkeletonCardSite';
import SiteTransferComponent from './layout/site/SiteTransfer';
import SitePublicLinkComponent from './layout/site/SitePublicLink';
import SiteCategoryComponent from './layout/site/SiteCategory';
import SitePublishComponent from './layout/site/SitePublish';
import SaveWebsiteComponent from './components/SaveWebsiteComponent';
import FirstWebsite from "./FirstWebsite";
import Breadcrumbs from "../general/Breadcrumbs.vue";

import { edit as editCategory, exclude as excludeCategory, getCategories } from '../../js/services/category';
import {
  deletedWebsitesSelected,
  exclude as excludeWebsite,
  getAllWebsites,
  getDashboardData
} from '../../js/services/editor/website';
import { editConfiguration as editConfigurationPage } from './../../js/services/editor/page';
import { get as getMirrors } from './../../js/services/editor/mirror';

import { mapActions, mapGetters } from 'vuex';
import { SweetModal } from "sweet-modal-vue";
import AlertBoxNewComponent from "../commons/AlertBoxNewComponent.vue";
import ModalDeleteComponent from "./components/ModalDelete.vue";
import SiteDomainComponent from "./layout/site/SiteDomain.vue";
import MoveCategory from "./modals/MoveCategory.vue";
import SearchInput from '../general/SearchInput.vue';

export default {
  name: 'Dashboard',
  components: {
    MoveCategory,
    SiteDomainComponent,
    ModalDeleteComponent,
    AlertBoxNewComponent,
    FirstWebsite,
    SiteNewComponent,
    ModalComponent,
    NavComponent,
    SiteCardComponent,
    PaginationComponent,
    ModalUploadImageComponent,
    SiteTransferComponent,
    SitePublicLinkComponent,
    SiteCategoryComponent,
    SweetModal,
    SitePublishComponent,
    SaveWebsiteComponent,
    SkeletonCardSiteComponent,
    SearchInput,
    Breadcrumbs
  },
  props: ['openNewSiteModal'],
  data() {
    return {
      loading: true,
      loaded: false,
      firstWebsite: false,
      loadingContentData: false,
      loadingAll: false,
      confirm_email: '',
      modalDomain: {
        show: 0
      },
      pagination: {
        normal: {
          current_page: 1
        }
      },
      categories: false,
      typeView: 'card',
      selectWebsites: {
        type: 'unitary', // unitary or all
        selectedWebsites: [],
        total: 0
      },
      selectMirrors: false,
      languages: [],
      websites_all: [],
      websites: {
        normal: [],
        mirrors: [],
        turbo: [],
      },
      websitesLength: {
        mirrors: 5,
        normal: 5
      },
      mirrors: [],
      newSite: {
        showModal: false,
        title: '',
        dominio: '',
        description: '',
        categories: [],
        image: '',
        status: 'inactive',
        language: this.$i18n.locale,
        typeInitial: '',
        typeBuilder: {
          build: {
            header: '',
            footer: '',
            body: ''
          },
          template: {
            idTemplate: ''
          }
        }
      },
      filters: {
        category: String(),
        status: '',
        search: String(),
        order: 'desc', // (asc desc)
        type: ''
      },
      dashboardData: {
        qty_websites: 0,
        qty_domains: 0,
        qty_visits: 0,
      },
      periodDashboardData: 'week', // week, month, all
      loadingDashboardData: false,
      filterSitesOrder: 'alphabetical_desc',
      filterPublishedUnpublished: '',
      showExitPopupAlert: false
    };
  },

  computed: {
    ...mapGetters({ modal: 'dashboard/modal' }),
  },

  watch: {
    'filterSitesOrder': function () {
      this.paginationChange();
    },
    'filterPublishedUnpublished': function () {
      this.paginationChange();
    },
    'getUser.lang': function (value) {
      this.newSite.language = value;
    },
    'typeView': function () {
      localStorage.setItem('websites-type-view', this.typeView);
    },
    'modal.alertDisconnectDomain.show': function (val) {
      if (val) {
        this.$refs.alertDisconnectDomain.open();
      }
    }
  },

  methods: {
    ...mapActions({ closeModalDisconnectDomain: 'dashboard/closeModalDisconnectDomain' }),

    closeAlertDisconnectDomain() {
      this.closeModalDisconnectDomain();
      this.$refs.alertDisconnectDomain.close();
    },

    newWebsite() {
      this.$router.push({
        name: 'CreateWebsite',
        query: { step: 'template' }
      });
    },

    deletedWebsites() {
      if (this.selectWebsites.type === 'all') {
        this.$refs.confirmDeleteSelectedAllWebsites.open();
      } else {
        this.$refs.confirmDeleteSelectedWebsites.open();
      }
    },

    confirmDeletedWebsites() {
      if (this.selectWebsites.type === 'all' && !this.confirm_email.length) {
        return;
      }

      this.loadingAll = true;
      deletedWebsitesSelected({ ...this.selectWebsites, confirm_email: this.confirm_email })
        .then(() => {
          this.$refs.confirmDeleteSelectedWebsites.close();
          this.$refs.confirmDeleteSelectedAllWebsites.close();
          this.confirm_email = '';
          this.clearSelect();
          this.updateWebsites();
        })
        .catch(() => {
          this.$snotify.warning(this.$t('ct-modal-deleted-confirm-email-error'));
        })
        .finally(() => {
          this.loadingAll = false;
        })
    },

    ...mapGetters({ getUser: 'user' }),

    closeMoveCategory() {
      this.categorySelected = false;
      this.$refs.moveFile.close();
    },

    publish(show, website) {
      this.modal.publish = {
        show: show,
        config: website
      };

      this.modal.saveTour.config = website;
    },

    deleteWebsite(website) {
      this.loadingAll = true;

      excludeWebsite(website)
        .then(() => {
          this.cancelModal('delete');
          this.updateWebsites();
        })
        .catch(error => console.warn(error))
        .finally(() => this.loadingAll = false);
    },

    openSaveTour() {
      this.modal.saveTour.show = 1;
    },

    disconnectDomain() {
      this.modal.domain.show = true;
      this.modal.domain.type = 'disconnect';
      this.modal.domain.title = this.$t('ct-domain-info');
    },

    cancelModal(type) {
      if (this.$refs[type]) {
        this.$refs[type].close();
        return;
      }
      this.modal[type].show = false;
      this.modal[type].config = '';

      document.querySelector('body').style.overflow = '';
      document.querySelector('body').style.height = '';
    },

    updateWebsites() {
      let self = this;
      this.loadingAll = true;

      getAllWebsites(1, { page_all: 1, order: 'desc' })
        .then(({ data }) => {
          self.websites.normal = data.data;
          self.pagination.normal = self.paginationData(data);
        })
        .catch(error => console.warn(error))
        .finally(() => this.loadingAll = false);
    },

    confirmSave(website) {
      this.$router.push({
        name: 'SitePages',
        params: { id: website.encrypted_id }
      });
    },

    clearNewSite() {
      this.newSite = {
        showModal: false,
        title: '',
        url: '',
        dominio: '',
        description: '',
        language: this.$i18n.locale,
        categories: [],
        image: '',
        status: 'inactive',
        typeInitial: '',
        typeBuilder: {
          build: {
            header: '',
            footer: '',
            body: ''
          },
          template: {
            idTemplate: ''
          }
        }
      };
    },

    closeModal() {
      this.newSite.showModal = false;
    },

    selectedWebsitesAll() {
      this.selectWebsites.type = this.selectWebsites.type === 'all' ? 'unitary' : 'all';
      this.selectWebsites.selectedWebsites = [];

      if (this.selectWebsites.type === 'all')
        this.selectWebsites.total = this.pagination.total;
      else
        this.selectWebsites.total = this.selectWebsites.selectedWebsites.length;

      this.$refs['select-all-websites'].checked = true;
    },

    checkedSelectAll(userEmail) {
      if (this.selectWebsites.type === 'all') {
        this.selectWebsites.type = 'unitary';
        this.$refs['select-all-websites'].checked = false;
      }

      if (!this.selectWebsites.selectedWebsites.includes(userEmail))
        this.selectWebsites.selectedWebsites.push(userEmail);

      this.changeUnitary();
    },

    changeUnitary() {
      this.selectWebsites.total = this.selectWebsites.selectedWebsites.length;
    },

    clearSelect() {
      this.selectWebsites = {
        type: 'unitary', // unitary or all
        selectedWebsites: [],
        total: 0
      };
    },

    paginationChange(currentPage = null) {
      let self = this;
      this.loadingContentData = true;

      if(this.filterSitesOrder == 'alphabetical_desc'){
        this.filters.order = 'desc';
        this.filters.type = 'alphabetical';
      } else if(this.filterSitesOrder == 'alphabetical_asc'){
        this.filters.order = 'asc';
        this.filters.type = 'alphabetical';
      } else if(this.filterSitesOrder == 'creation_asc'){
        this.filters.order = 'asc';
        this.filters.type = 'creation';
      } else if(this.filterSitesOrder == 'creation_desc'){
        this.filters.order = 'desc';
        this.filters.type = 'creation';
      } else if(this.filterSitesOrder == 'edition_asc'){
        this.filters.order = 'asc';
        this.filters.type = 'edition';
      } else {
        this.filters.order = '';
        this.filters.type = '';
      }

      if(this.filterPublishedUnpublished == 'active'){
        this.filters.status = 'active';
      } else if(this.filterPublishedUnpublished == 'inactive') {
        this.filters.status = 'inactive';
      } else {
        this.filters.status = '';
      }

      getAllWebsites(
        currentPage ? currentPage : this.pagination.normal.current_page,
        this.filters
      ).then(({ data }) => {
        self.websites.normal = data.data;
        self.pagination.normal = self.paginationData(data);

        self.addParamsToLocation(self.filters);
      })
        .finally(() => {
          this.loadingContentData = false;
        });
    },

    addParamsToLocation(params) {
      let str = Object.keys(params)
        .map(key => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        })
        .join('&');
      let uri = window.location.href.toString();

      if (uri.indexOf('?') > 0) uri = uri.substring(0, uri.indexOf('?'));

      if (str) window.location.href = uri + '?' + str;
    },

    openNewCategory() {
      this.$refs.categoryModal.open();
    },

    cancelCategory() {

    },

    newCategory(category) {
      this.categories.push(category);
      this.updateWebsites();
    },

    updateCategory(category) {
      this.loadingAll = true;
      editCategory(category)
        .then(data => {
          console.log('CATEGORY - EDIT');
        })
        .catch(error => {
          console.warn(error);
        })
        .finally(() => this.loadingAll = false);
    },

    deleteCategory(category) {
      this.loadingAll = true;
      excludeCategory(category)
        .then(data => {
          this.removeCategory(category);
          this.clearCategory();
        })
        .catch(error => {
          console.warn(error);
        })
        .finally(() => this.loadingAll = false);
    },

    removeCategory(category) {
      // Deleta a categoria do objeto
      this.categories = this.categories.filter(function (element) {
        return element.id !== category.id;
      });
    },

    saveImagePage(image) {
      let configuration = {
        og_image: image
      };

      if (this.modal.image.page.configuration) {
        this.modal.image.page.configuration.og_image = image;
      } else
        this.modal.image.page = { ...this.modal.image.page, configuration };

      editConfigurationPage(this.modal.image.page)
        .then(data => {
          this.closeUploadPage();
          window.location.reload();
        })
        .catch(error => {
          console.warn(error);
        });
    },

    closeUploadPage() {
      let values = {
        action: 'close',
        type: 'Images',
        save: this.saveImagePage,
        close: this.closeUploadPage
      };

      this.$root.$emit('fileMananger', values);

      this.modal.image = {
        show: false,
        page: ''
      };
    },

    uploadImagePage(page) {
      this.modal.image.page = page;

      let values = {
        action: 'open',
        type: 'Images',
        save: this.saveImagePage,
        close: this.closeUploadPage
      };

      this.$root.$emit('fileMananger', values);
    },

    /* public link website - begin */
    openPublicLink(show, config = '', action = '') {
      this.modal.publicLink = {
        show: show,
        action: action,
        config: config
      };
    },
    /* public link website - end */
    paginationData(data) {
      let page_meta = {
        current_page: data.current_page,
        last_page: data.last_page,
        from: data.from,
        path: data.path,
        per_page: data.per_page,
        to: data.to,
        total: data.total
      };

      return page_meta;
    },


    getWebsitesData() {
      let self = this;
      this.paginationChange();
      getAllWebsites(1, this.filters)
        .then(res => {
          self.websites.normal = res.data.data;
        });
    },

    getStorageFilters() {
      try {
        let filtersWebsites = localStorage.getItem('dashboard-filters-website-list');

        if (!filtersWebsites) return;

        let filters = JSON.parse(filtersWebsites);

        this.filters.order = filters.order;
        this.filters.type = filters.type;
      } catch (e) {
        console.warn(e);
      }
    },

    setQueryParams() {
      let query = this.$route.query;

      if (query.category)
        this.filters.category = query.category;


      if (query.search)
        this.filters.search = query.search;

    },

    getCategory() {
      let category_id = this.filters.category;
      if (category_id && this.categories)
        return this.categories.find(category => category.id === parseInt(category_id));

      return false;
    },

    clearCategory() {
      this.filters.category = false;
      if (this.$refs['filters-component']) this.$refs['filters-component'].changeCategory(false);
    },

    websitesLengthLoad() {
      if (localStorage.getItem('websites-normal-length') !== null) {
        const countItem = parseInt(localStorage.getItem('websites-normal-length'));
        this.websitesLength.normal = countItem ? countItem : 5;
      }
    },

    typeViewLoad() {
      if (localStorage.getItem('websites-type-view') !== null)
        this.typeView = localStorage.getItem('websites-type-view');
    },

    getDashboardUserData(){
      this.loadingDashboardData = true;
      getDashboardData(this.periodDashboardData)
        .then(res => {
          if(res.status == 200){
            this.dashboardData = res.data;
          }
        })
        .finally(() => {
          this.loadingDashboardData = false;
        });
    }
  },

  async mounted() {
    this.newSite.showModal = this.openNewSiteModal;

    let self = this;

    this.typeViewLoad();
    this.websitesLengthLoad();
    this.getDashboardUserData();

    await this.getStorageFilters();

    await this.setQueryParams();

    this.loadingAll = true;

    await Promise.all([
      getCategories(),
      getAllWebsites(1, this.filters),
      getMirrors()
    ])
      .then(data => {
        const [categories, websites, mirrors] = data;

        self.categories = categories.data;

        self.websites.normal = websites.data.data;
        self.pagination.normal = self.paginationData(websites.data);

        localStorage.setItem('websites-normal-length', websites.data.length);

        if (websites.data.length === 0)
          self.firstWebsite = true;

        /** MIRROR - ALAN */
        self.websites.mirrors = mirrors.data;
      })
      .catch(error => {
        console.warn(error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loadingAll = false;
          this.loading = false;

        }, 1200);
      });

    this.$nextTick(() => {
      this.$refs['filters-component'].setOrderBySelected();

      let category = this.getCategory();
      if (category) this.$refs['filters-component'].changeCategory(category);
    });

    if(localStorage.getItem('is_bundle') == 'show-message'){
      this.showExitPopupAlert = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.ba-card.ba-statistics .ba-content .ba-data {
  font-size: 44px;
}

.custom-container {
  min-height: 500px;
  overflow-y: hidden;
}

.dashboard-choose-view {
  div {
    color: #C4D1E0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    &.selected {
      color: #0080FC;
    }
  }

  i[class^="ct-icon-"] {
    font-size: 24px;
    margin-left: 12px;
    cursor: pointer;
  }
}

.container-dashboard {
  min-width: 300px;
  min-height: calc(100vh - 80px);
  padding-bottom: 100px;
}

.nav-list-websites {
  display: flex;
  justify-content: center;
  align-items: center;

  border-bottom: 1px solid rgba(#0080FC, 0.5);

  .nav-link {
    font-family: 'Muli', sans-serif;
    font-size: 16px;
    color: #434343;
    text-transform: capitalize;
    border: 0;
    transition: color 0.2s;

    cursor: pointer;

    &.active {
      font-weight: bold;
      color: #0080FC;
      background: #E9EDF2;
      border: 0;
      border-bottom: 3px solid #0080FC;

    }
  }
}

.button-tag {
  height: 40px;
  margin-top: 3px !important;
  text-transform: uppercase;
}

.container-box {
  padding: 0;

  @media (max-width: 576px) {
    padding: 0;
  }
}

.dropdown-menu {
  right: 0;
  left: auto;
}

.box {
  width: 23%;
}

.new-website {
  background: #F8FAFD 0% 0% no-repeat padding-box;
  border: 1px dashed #05C1FC;
  cursor: pointer;
  border-radius: 16px;
  min-height: 259px;
}

.new-website .btn:hover {
  color: #0056b3;
}

.builder-action-multiple-websites_checkbox-all-label{
  margin-bottom: 0;
}

.box-info {
  display: flex;
  flex-direction: column;
  text-align: center;
}

@media (max-width: 575.98px) {

  .box {
    max-width: 94%;
    min-width: 300px;
    margin: 15px 3%;
  }

}

@media (min-width: 576px) and (max-width: 767.98px) {

  .box {
    max-width: 90%;
    min-width: 300px;
    margin: 15px 5%;
  }

}

@media (min-width: 768px) and (max-width: 1049.99px) {

  .box {
    max-width: 46%;
    min-width: 300px;
    margin: 15px 2%;
  }

  .btn-add-tag {
    font-size: 10px !important;
    margin-right: 30px !important;
  }

}

@media (min-width: 1050px) and (max-width: 1299.98px) {

  .box {
    max-width: 31.33%;
    min-width: 31.33%;
    margin: 15px 1%;
  }

}

@media (min-width: 1300px) {

  .box {
    min-width: 31.33%;
    max-width: 31.33%;
    margin: 0 1% 15px 1%;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue